import './FormManager.scss'
import React, { useState, useEffect } from 'react';
import {Tabs } from 'antd';
import {Row, Col, Input, Icon } from 'antd'
import {FormTablePage} from './components'
import { getAreasPromise } from '../../promises';

const FormManager = ({currentUser, categories, filtersSideBar = {}}) => {

	const [areas, setAreas] = useState(null)

	useEffect(() => {
		getAreasPromise().then((areas) => {
			setAreas(areas)
		})
	}, []);

    return (
		<div className="cdi-form-manager">
			<div className="form-manager-content">
				<Row>
					<Col span={24}>
						<FormTablePage currentUser={currentUser} areas={areas} filtersSideBar={filtersSideBar} categories={categories}/>
					</Col>
				</Row>
			</div>
		</div>
    );
}
export default FormManager
